import { Components, Theme } from '@mui/material';

const SMALL_STYLES = {
  width: '72px',
  height: '31px',
  thumb: {
    width: '15px',
    height: '15px',
  },
  textBefore: {
    top: '8px',
    left: '-32px',
    right: '-31px',
  },
};

const MEDIUM_STYLES = {
  width: '94px',
  height: '44px',
  thumb: {
    width: '24px',
    height: '24px',
  },
  textBefore: {
    top: '13px',
    horizontal: '-40px',
  },
};

export const buildMuiSwitchComponent = (): Components<Omit<Theme, 'components'>>['MuiSwitch'] => ({
  styleOverrides: {
    root: ({ theme }) => ({
      background: theme.palette.secondary.main,
      borderRadius: '4px',
      padding: '10px',
      '&.CustomSwitch-checked': {
        boxShadow: '0px 5px 10px rgba(109, 186, 232, 0.34)',
      },
      '&.CustomSwitch-unchecked': {
        boxShadow: '0px 5px 10px rgba(7, 23, 36, 0.34)',
      },
      '& .Mui-disabled': {
        background: theme.palette.primary[30],
      },
      '& .MuiSwitch-thumb': {
        borderRadius: '4px',
        background: '#fff',
        boxShadow: 'none',
        '&:before': {
          color: '#fff',
          position: 'absolute',
        },
      },

      '& .MuiSwitch-switchBase': {
        padding: '10px',
        '&:not(.Mui-checked,.Mui-disabled),&.Mui-disabled': {
          '&:before': {
            content: '""',
            position: 'absolute',
            zIndex: '-1',
            left: '0px',
            top: '0px',
            background: theme.palette.accent.dark,
          },
        },
        '&.Mui-disabled': {
          '&:before': {
            background: theme.palette.primary[30],
          },
        },
        '&.Mui-disabled.Mui-checked': {
          '&:before': {
            right: '0',
            left: 'auto',
          },
        },
        '&.Mui-checked': {
          '&:before': {
            content: '""',
            position: 'absolute',
            zIndex: '-1',
            left: 'auto',
            right: '0',
            top: '0px',
            width: MEDIUM_STYLES.width,
            height: MEDIUM_STYLES.height,
            boxShadow: '0px 5px 10px rgba(109, 186, 232, 0.34)',
          },
        },
      },

      '& .MuiSwitch-track': {
        display: 'none',
      },

      '&.MuiSwitch-sizeMedium': {
        width: MEDIUM_STYLES.width,
        height: MEDIUM_STYLES.height,

        '& .MuiSwitch-thumb': {
          width: MEDIUM_STYLES.thumb.width,
          height: MEDIUM_STYLES.thumb.height,
          '&:before': {
            right: MEDIUM_STYLES.textBefore.horizontal,
            top: MEDIUM_STYLES.textBefore.top,
          },
        },

        '& .MuiSwitch-switchBase': {
          '&:not(.Mui-checked,.Mui-disabled),&.Mui-disabled': {
            '&:before': {
              width: MEDIUM_STYLES.width,
              height: MEDIUM_STYLES.height,
            },
          },
        },
        '& .Mui-checked': {
          left: '30px',
          '& .MuiSwitch-thumb': {
            '&:before': {
              left: MEDIUM_STYLES.textBefore.horizontal,
              top: MEDIUM_STYLES.textBefore.top,
            },
          },
        },
      },

      '&.MuiSwitch-sizeSmall': {
        width: SMALL_STYLES.width,
        height: SMALL_STYLES.height,

        '& .MuiSwitch-thumb': {
          width: SMALL_STYLES.thumb.width,
          height: SMALL_STYLES.thumb.height,
          borderRadius: '4px',
          background: '#fff',
          boxShadow: 'none',
          '&:before': {
            right: SMALL_STYLES.textBefore.right,
            top: SMALL_STYLES.textBefore.top,
            fontSize: '12px',
          },
        },
        '& .MuiSwitch-switchBase': {
          padding: '8px',
          '&:not(.Mui-checked,.Mui-disabled),&.Mui-disabled': {
            '&:before': {
              width: SMALL_STYLES.width,
              height: SMALL_STYLES.height,
            },
          },
        },
        '& .Mui-checked': {
          left: '25px',
          '& .MuiSwitch-thumb': {
            '&:before': {
              left: SMALL_STYLES.textBefore.left,
              top: SMALL_STYLES.textBefore.top,
              fontSize: '12px',
            },
          },
        },
      },
    }),
  },
  defaultProps: {},
});
